import React from 'react';
import styles from './button.module.css';

export default function Button(props) {
    return (
        <div className={styles.buttonCentered}>
            <a href="/" class={styles.btn}>Check other streams</a>
        </div>
    );
}